import { Component, createRef } from 'react';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import { CommonPatientDetails, ConfirmPopup } from '../../../../Components/Common Components/CommonComponents';
import { Box, Button, TextField, Tooltip, Typography, FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Divider, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { DateTime } from 'luxon';
import Loader from '../../../../Components/Loader';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { withTranslation } from 'react-i18next';

const ITEM_HEIGHT = 80;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: '15vw',
        },
    },
};

class DocMedicalCertific extends Component {
    constructor(props) {
        super(props)
        this.state = {
            patientDetails: {},
            patientId: '',
            doctor_details: {
                city_name: "",
                doctor_name: '',
                regNo: '',
                doctor_id: null
            },
            doctor_content: "",
            date: new Date(),
            companyName: '',
            designation: '',
            diagnosisDetails: '',
            fromDateOpen: false,
            fromDate: null,
            toDateOpen: false,
            toDate: null,
            effectiveDateOpen: false,
            effectiveDate: null,
            dateOpen: false,
            disableInputs: false,
            // Template related states
            selectTemplate: '',
            templateList: [],
            isTempAdd: false,
            addLayoutName: '',
            tempContent: '',
            selectedID: null,
            deleteTemp: false,
            selecDelID: null,
            isDefault: false,
            edittempName: false,
            hasSavedData: false,
        }
        this.boxRef = createRef();
    }

    componentDidMount = () => {
        let states = this.state
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        states["patientId"] = appointmentId?.patient_id
        states["appointment_id"] = appointmentId?.appointment_id
        states["doctor_details"]["doctor_name"] = UserData?.doctor_name
        states["doctor_details"]["doctor_id"] = UserData?.doctor_id
        states["doctor_details"]["city_name"] = UserData?.clinic_city
        states["doctor_details"]["regNo"] = (UserData?.module_name === 'JMO') ? localGetItem('regNo') :UserData?.registeration_number
        states["patientDetails"] = appointmentId;
        if (this.boxRef.current) {
            this.boxRef.current.innerHTML = this.state.doctor_content;
        }
        this.setState({
            states
        }, () => {
            this.getPatientDetailData(() => {
                this.getMedicalCertifiData(() => {
                    this.getTempData()
                })
            })
        })
    }

    getPatientDetailData = (callback) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState((prevState)=> ({
                            patientDetails: response?.data?.data ? {...prevState.patientDetails, ...response?.data?.data} : {},
                        }), () => {
                            // Only regenerate content if no saved data exists
                            if (!this.state.hasSavedData) {
                                this.handleChangeMainText()
                            }
                            if (callback) callback()
                        })
                    } else {
                        if (callback) callback()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    if (callback) callback()
                })
        } catch (error) {
            this.errorMessage(error.message)
            if (callback) callback()
        }
    }

    getMedicalCertifiData = (callback) => {
        try {
            let states = this.state
            this.LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.DOC_MEDICAL_CERTFICATE_GET + `?patient_id=${states.patientId}&appointment_id=${states?.appointment_id ? states?.appointment_id : null}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.medical_data?.length > 0 ? response?.data?.medical_data[response?.data?.medical_data?.length - 1] : {}
                        this.setState({
                            id: data.id || null,
                            companyName: data.company_name || '',
                            designation: data.designation_name || '',
                            diagnosisDetails: data.diagnosis_details || '',
                            fromDate: data.from_date ? new Date(data.from_date) : null,
                            toDate: data.to_date ? new Date(data.to_date) : null,
                            effectiveDate: data.effective_date ? new Date(data.effective_date) : null,
                            date: data.date ? new Date(data.date) : new Date(),
                            doctor_details: {
                                ...states.doctor_details,
                                city_name: data.location || states.doctor_details?.city_name,
                                regNo: data.registration_proof_number || states.doctor_details?.regNo,
                            },
                        }, () => {
                            if (data?.medical_notes) {
                                this.setState({
                                    doctor_content: data.medical_notes,
                                    disableInputs: true,
                                    hasSavedData: true
                                }, () => {
                                    if (this.boxRef.current) {
                                        setTimeout(() => {
                                            this.boxRef.current.innerHTML = data.medical_notes;
                                        }, 100);
                                    }
                                    this.LoaderFunction(false);
                                    if (callback) callback()
                                })
                            } else {
                                this.setState({ hasSavedData: false }, () => {
                                    this.handleChangeMainText()
                                    this.LoaderFunction(false);
                                    if (callback) callback()
                                })
                            }
                        });
                    } else {
                        this.LoaderFunction(false);
                        if (callback) callback()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.LoaderFunction(false);
                    if (callback) callback()
                })
        } catch (error) {
            this.errorMessage(error?.message)
            this.LoaderFunction(false);
            if (callback) callback()
        }

    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            disableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            disableBtn: false
        })
    }

    LoaderFunction = (value) => {
        this.setState({
            isLoader: value
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    handleMedCertifiSave = () => {
        try {
            let states = this.state
            let data = {
                "id": states.id || null,
                "doctor_id": states.doctor_details?.doctor_id || null,
                "patient_id": states.patientId || null,
                "designation_name": states.designation || '',
                "company_name": states.companyName || '',
                "appointment_id": states.patientDetails?.appointment_id ? states.patientDetails?.appointment_id : this.state.appointment_id ? this.state.appointment_id : null,
                "diagnosis_details": states.diagnosisDetails || '',
                "from_date": states.fromDate ? DateTime.fromJSDate(states?.fromDate)?.toFormat('yyyy-MM-dd') : '',
                "to_date": states.toDate ? DateTime.fromJSDate(states?.toDate)?.toFormat('yyyy-MM-dd') : '',
                "date": states.date ? DateTime.fromJSDate(states?.date)?.toFormat('yyyy-MM-dd') : '',
                "effective_date": states.effectiveDate ? DateTime.fromJSDate(states?.effectiveDate)?.toFormat('yyyy-MM-dd') : '',
                "medical_notes": states.doctor_content,
                "patient_name": states.patientDetails?.first_name + states.patientDetails?.last_name || "",
                "doctor_name": states.doctor_details?.doctor_name || '',
                "location": states.doctor_details?.city_name || '',
                "registration_proof_number": states.doctor_details?.regNo || ''
            }
            this.LoaderFunction(true);
            RestAPIService.create(data, Serviceurls.DOC_MEDICAL_CERTFICATE_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            disableInputs: true,
                            id: response?.data?.medical_data?.id || null
                        }, () => {
                            this.getMedicalCertifiData()
                        })
                        this.successMessage(response?.data?.message)
                        this.LoaderFunction(false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (e) {
            this.errorMessage(e?.message)
        }
    }

    handleMedCertifiPrint = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.DOC_MEDICAL_CERTFICATE_GET}?patient_id=${this.state.patientId}&appointment_id=${this.state?.appointment_id ? this.state?.appointment_id : null}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    handleChange = (e, stateKey) => {
        let states = this.state;
        if (stateKey === "city_name" || stateKey === "regNo") {
            states["doctor_details"][stateKey] = e.target.value
        } else {
            states[stateKey] = e.target.value
        }
        this.setState({ states }, () => this.handleChangeMainText())
    }


    renderTextField = (label, stateKey) => {
        let states = this.state;
        let value = (stateKey === "city_name" || stateKey === "regNo") ? states["doctor_details"][stateKey] : states[stateKey]
        return (
            <Box margin={'1vw'}>
                <TextField
                    label={label}
                    inputProps={{ maxLength: stateKey === 'diagnosisDetails' ? 250 : (stateKey === "companyName" || stateKey === "city_name") ? 75 : 100, emed_tid: stateKey }}
                    rows={stateKey === 'diagnosisDetails' && 4}
                    multiline={stateKey === "diagnosisDetails" ? true : false}
                    disabled={stateKey === "regNo" ? true : states.disableInputs}
                    sx={{ width: "100%" }}
                    size="small"
                    autoComplete="off"
                    name={label}
                    value={value ? value : ""}
                    onChange={(e) => { this.handleChange(e, stateKey) }}
                />
            </Box>
        )
    }

    handleDatePickerPopup = (stateKey, open = false) => {
        let states = this.state;
        states[stateKey] = open ? true : false
        this.setState({ states })
    }

    renderDatePicker = (label, statekey, popupState) => {
        let states = this.state;
        return (
            <Box sx={{ margin: '1vw' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        open={states[popupState]}
                        onOpen={() => { this.handleDatePickerPopup(popupState, true) }}
                        onClose={() => { this.handleDatePickerPopup(popupState, false) }}
                        value={states[statekey]}
                        label={label}
                        name={label}
                        disabled={states.disableInputs}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                            (newDate) => {
                                states[statekey] = newDate?.$d ? newDate?.$d : newDate
                                this.setState({
                                    states
                                }, () => this.handleChangeMainText())
                            }}
                        renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: statekey === "effectiveDate" ? '47%' : '100%' }} size='small' {...params} onClick={() => { this.handleDatePickerPopup(popupState, true) }} />}
                    />
                </LocalizationProvider>
            </Box>
        )
    }

    handleChangeMainText = () => {
        let states = this.state
        const value = `I, Dr. ${states.doctor_details?.doctor_name} after careful personal examination of the case, hereby certify that ${states?.patientDetails?.title ? states?.patientDetails?.title : 'Dr./Shri/Smt./Ms.'} ${states?.patientDetails?.first_name ? states?.patientDetails?.first_name : '_____'} ${states?.patientDetails?.last_name ? ` ${states?.patientDetails?.last_name}` : ""}<b>${states?.designation ? `, ${states?.designation}` : ''}</b> (name & designation of applicant) of the <b>${states.companyName ? states.companyName : '_____'}</b>, whose signature is given above is suffering from <b>${states?.diagnosisDetails ? states?.diagnosisDetails : "_____"}</b> and, Therefore, I consider, that a period of duty absense from <b>${states?.fromDate ? DateTime.fromJSDate(states?.fromDate)?.toFormat('dd-MM-yyyy') : "_____"}</b> to <b>${states.toDate ? DateTime.fromJSDate(states?.toDate)?.toFormat('dd-MM-yyyy') : '_____'}</b> effective from <b>${states?.effectiveDate ? DateTime.fromJSDate(states?.effectiveDate)?.toFormat('dd-MM-yyyy') : "_____"}</b> is absolutely necessary for the restoration of his/her health.`;
        this.setState({
            doctor_content: value
        }, () => {
            if (this.boxRef.current) {
                this.boxRef.current.innerHTML = value;
            }
        })
    }

    handleValidation = () => {
        let states = this.state
        let msg = null
        if (!states.companyName) {
            msg = "Enter Company Name"
        } else if (!states.diagnosisDetails) {
            msg = "Enter Diagnosis Details"
        } else if (!states.fromDate) {
            msg = "Select From Date"
        } else if (!states.toDate) {
            msg = "Select To Date"
        } else if (!states.effectiveDate) {
            msg = "Select Effective Date"
        } else if (!states.doctor_details?.city_name) {
            msg = "Enter Place"
        } else if (!states.date) {
            msg = "Select Date"
        } else if (!states.doctor_details?.regNo) {
            msg = "Enter Registration No"
        } else if (DateTime.fromJSDate(states?.fromDate) > DateTime.fromJSDate(states?.toDate)) {
            msg = "From Date is Greater than To Date"
        } else {
            msg = null
        }

        if (msg) {
            this.errorMessage(msg)
        } else {
            this.handleMedCertifiSave()
        }
    }

    handleTemplateValidation = () => {
        let states = this.state
        let msg = null
        if (!(states.companyName.trim())) {
            msg = "Enter Company/Office Name"
        } else if (!(states.diagnosisDetails.trim())) {
            msg = "Enter Diagnosis Details"
        } else if (!states.fromDate) {
            msg = "Select From Date"
        } else if (!states.toDate) {
            msg = "Select To Date"
        } else if (!states.effectiveDate) {
            msg = "Select Effective Date"
        } else {
            msg = null
        }

        if (msg) {
            this.errorMessage(msg)
        } else {
            this.setState({ isTempAdd: true })
        }
    }

    handleclear = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        this.state["doctor_details"]["city_name"] = UserData?.clinic_city
        this.setState({
            doctor_content: "",
            date: new Date(),
            companyName: '',
            designation: '',
            diagnosisDetails: '',
            fromDateOpen: false,
            fromDate: null,
            toDateOpen: false,
            toDate: null,
            effectiveDateOpen: false,
            effectiveDate: null,
            dateOpen: false,
            disableInputs: false,
            hasSavedData: false,
            doctor_details: this.state.doctor_details,
        }, () => {
            // Apply default template if exists, otherwise generate default content
            this.getTempData(true)
        })
    }

    getTempData = (applyDefault = false) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_MEDICAL_FORM_TEMPLATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const templateList = response?.data?.data || [];
                        const defaultTemplate = templateList.find(item => item.default_template === true);
                        
                        // Only apply default template if:
                        // 1. applyDefault is true (called from reset), OR
                        // 2. No saved data exists AND inputs are not disabled
                        const shouldApplyDefault = applyDefault || (!this.state.hasSavedData && !this.state.disableInputs);
                        
                        if (defaultTemplate?.medical_notes && shouldApplyDefault) {
                            const templateContent = defaultTemplate.medical_notes;
                            const extractedFields = this.extractFieldsFromTemplate(templateContent);
                            this.setState({
                                templateList,
                                doctor_content: templateContent,
                                tempContent: templateContent,
                                selectTemplate: defaultTemplate.id,
                                edittempName: true,
                                // Auto-fill form fields from extracted values
                                companyName: extractedFields.companyName || this.state.companyName,
                                designation: extractedFields.designation || this.state.designation,
                                diagnosisDetails: extractedFields.diagnosisDetails || this.state.diagnosisDetails,
                                fromDate: extractedFields.fromDate || this.state.fromDate,
                                toDate: extractedFields.toDate || this.state.toDate,
                                effectiveDate: extractedFields.effectiveDate || this.state.effectiveDate,
                            }, () => {
                                if (this.boxRef.current) {
                                    this.boxRef.current.innerHTML = this.state.doctor_content;
                                }
                            });
                        } else {
                            this.setState({
                                templateList,
                                selectTemplate: shouldApplyDefault ? '' : this.state.selectTemplate,
                                edittempName: shouldApplyDefault ? false : this.state.edittempName,
                            }, () => {
                                // If applyDefault was requested but no default template exists, generate default content
                                if (applyDefault && !defaultTemplate?.medical_notes) {
                                    this.handleChangeMainText()
                                }
                            });
                        }
                    }
                })
                .catch((e) => {
                    this.errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    getContentMap = () => {
        let states = this.state;
        return {
            doctor_name: states.doctor_details?.doctor_name || '',
            patient_title: states?.patientDetails?.title || 'Dr./Shri/Smt./Ms.',
            patient_first_name: states?.patientDetails?.first_name || '_____',
            patient_last_name: states?.patientDetails?.last_name || '',
            designation: states?.designation || '',
            company_name: states.companyName || '_____',
            diagnosis_details: states?.diagnosisDetails || '_____',
            from_date: states?.fromDate ? DateTime.fromJSDate(states?.fromDate)?.toFormat('dd-MM-yyyy') : '_____',
            to_date: states?.toDate ? DateTime.fromJSDate(states?.toDate)?.toFormat('dd-MM-yyyy') : '_____',
            effective_date: states?.effectiveDate ? DateTime.fromJSDate(states?.effectiveDate)?.toFormat('dd-MM-yyyy') : '_____',
        };
    }

    addTempLayout = () => {
        try {
            let states = this.state
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            let data = {
                "doctor_id": UserData?.doctor_id || null,
                "template_name": states.addLayoutName.trim() || '',
                "medical_notes": states.tempContent || '',
                "default_template": states.isDefault
            }
            if (states.selectedID) {
                data['template_id'] = states.selectedID
            }

            let url = states.selectedID ? RestAPIService.updateWithOutId(data, Serviceurls.DOC_MEDICAL_FORM_TEMPLATE) : RestAPIService.create(data, Serviceurls.DOC_MEDICAL_FORM_TEMPLATE)

            url.then((response) => {
                if (response.data.status === 'success') {
                    this.getTempData()
                    this.setState({
                        addLayoutName: '',
                        isTempAdd: false,
                        selectedID: null,
                        tempContent: '',
                        isDefault: false,
                    })
                    this.successMessage(response.data.message)
                }
            })
                .catch((e) => {
                    this.errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    deleteTempData = () => {
        try {
            let states = this.state
            let data = {
                "template_id": states.selecDelID || null,
            }

            RestAPIService.delete(Serviceurls.DOC_MEDICAL_FORM_TEMPLATE, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.getTempData()
                        this.setState({
                            deleteTemp: false,
                            selecDelID: null,
                            selectTemplate: ''
                        })
                        this.successMessage(response.data.message)
                    }
                })
                .catch((e) => {
                    this.errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    extractPlaceholders = (str) => {
        const matches = str.match(/{{\s*[\w\.]+\s*}}/g) || [];
        const placeholders = {};
        matches.forEach(match => {
            const cleanKey = match.replace(/{{\s*|\s*}}/g, '');
            placeholders[match] = cleanKey;
        });
        return Object.keys(placeholders);
    }

    restoreTemplate = (userText, commonTemplate, contentMap) => {
        const placeholders = this.extractPlaceholders(commonTemplate);
        let restored = userText;

        placeholders.forEach(placeholder => {
            const key = placeholder.replace(/{{\s*|\s*}}/g, '');
            const value = contentMap[key];

            if (!value || value === '_____') return;

            const safeValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(safeValue, 'g');
            restored = restored.replace(regex, placeholder);
        });

        // Replace "_____" placeholders back
        let dashCount = 0;
        const dashPlaceholders = ['company_name', 'diagnosis_details', 'from_date', 'to_date', 'effective_date'];
        restored = restored.replace(/_{3,}/g, () => {
            if (dashCount < dashPlaceholders.length) {
                return `{{${dashPlaceholders[dashCount++]}}}`;
            }
            return '_____';
        });

        return restored;
    }

    replacePlaceholders = (template, contentMap) => {
        let result = template;
        Object.keys(contentMap).forEach(key => {
            const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
            result = result.replace(regex, contentMap[key] || '_____');
        });
        return result;
    }

    extractFieldsFromTemplate = (content) => {
        const extractedFields = {};
        
        try {
            // Extract designation: between <b>, and </b> (name & designation
            const designationMatch = content.match(/<b>,\s*([^<]*)<\/b>\s*\(name & designation/);
            if (designationMatch && designationMatch[1]) {
                extractedFields.designation = designationMatch[1].trim();
            }

            // Extract company: between of the <b> and </b>, whose signature
            const companyMatch = content.match(/of the <b>([^<]*)<\/b>, whose signature/);
            if (companyMatch && companyMatch[1]) {
                extractedFields.companyName = companyMatch[1].trim();
            }

            // Extract diagnosis: between suffering from <b> and </b> and, Therefore
            const diagnosisMatch = content.match(/suffering from <b>([^<]*)<\/b> and, Therefore/);
            if (diagnosisMatch && diagnosisMatch[1]) {
                extractedFields.diagnosisDetails = diagnosisMatch[1].trim();
            }

            // Extract from date: between absense from <b> and </b> to
            const fromDateMatch = content.match(/absense from <b>([^<]*)<\/b> to/);
            if (fromDateMatch && fromDateMatch[1] && fromDateMatch[1] !== '_____') {
                const dateParts = fromDateMatch[1].trim().split('-');
                if (dateParts.length === 3) {
                    // Convert DD-MM-YYYY to Date object
                    extractedFields.fromDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                }
            }

            // Extract to date: between </b> to <b> and </b> effective
            const toDateMatch = content.match(/<\/b> to <b>([^<]*)<\/b> effective/);
            if (toDateMatch && toDateMatch[1] && toDateMatch[1] !== '_____') {
                const dateParts = toDateMatch[1].trim().split('-');
                if (dateParts.length === 3) {
                    extractedFields.toDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                }
            }

            // Extract effective date: between effective from <b> and </b> is absolutely
            const effectiveDateMatch = content.match(/effective from <b>([^<]*)<\/b> is absolutely/);
            if (effectiveDateMatch && effectiveDateMatch[1] && effectiveDateMatch[1] !== '_____') {
                const dateParts = effectiveDateMatch[1].trim().split('-');
                if (dateParts.length === 3) {
                    extractedFields.effectiveDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                }
            }
        } catch (e) {
            console.error('Error extracting fields from template:', e);
        }

        return extractedFields;
    }

    popClose = () => {
        this.setState({
            deleteTemp: false,
            selecDelID: null
        })
    }

    renderLayAdd = () => {
        const { t } = this.props
        return (
            <Dialog open={this.state.isTempAdd} >
                <DialogTitle className='eMed_CreditPoP_TitleDiv' sx={{ borderColor: Colors.themeDark }}>
                    <Typography marginLeft={"1vw"}>{t("Add Template Name")}</Typography>
                    <Button onClick={() => { this.setState({ isTempAdd: false, addLayoutName: '', selectedID: null }) }} >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ padding: "2vw" }}>
                    <TextField
                        inputProps={{ maxLength: 30 }}
                        sx={{ width: "20vw", marginTop: "2vw" }}
                        size='small'
                        label={t("Template Name")}
                        value={this.state.addLayoutName}
                        onChange={(event) => {
                            let alphanum = CommonValidation.alphanumValidation(event.target.value);
                            if (alphanum || event.target.value === '') {
                                this.setState({
                                    addLayoutName: event.target.value
                                })
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => { this.setState({ addLayoutName: '' }) }}>{t("Clear")}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => {
                        if (this.state.addLayoutName !== '') {
                            this.setState({
                                tempContent: this.state.doctor_content
                            }, () => {
                                this.addTempLayout()
                            })
                        } else {
                            this.errorMessage(t('Please add the template name'));
                        }
                    }}>{this.state.selectedID ? t("Rename") : t("Add")}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    renderTemplateDropdown = () => {
        const { t } = this.props;
        let states = this.state;
        return (
            <FormControl size="small" sx={{ width: '13vw', paddingRight: '0.5vw' }}>
                <InputLabel id="medical_form_template">{t('Select Template')}</InputLabel>
                <Select
                    labelId="medical_form_template"
                    id="medical-template-select"
                    disabled={this.state.disableInputs}
                    value={!this.state.disableInputs ? states.selectTemplate : ''}
                    label={t('Select Template')}
                    onChange={(e) => {
                        const selectedTemplate = this.state.templateList.find(item => item.id == e.target.value);
                        if (selectedTemplate) {
                            const templateContent = selectedTemplate?.medical_notes || '';
                            // Extract field values from template content
                            const extractedFields = this.extractFieldsFromTemplate(templateContent);
                            
                            this.setState({
                                edittempName: true,
                                selectTemplate: selectedTemplate.id,
                                doctor_content: templateContent,
                                companyName: extractedFields.companyName || this.state.companyName,
                                designation: extractedFields.designation || this.state.designation,
                                diagnosisDetails: extractedFields.diagnosisDetails || this.state.diagnosisDetails,
                                fromDate: extractedFields.fromDate || this.state.fromDate,
                                toDate: extractedFields.toDate || this.state.toDate,
                                effectiveDate: extractedFields.effectiveDate || this.state.effectiveDate,
                            }, () => {
                                if (this.boxRef.current) {
                                    this.boxRef.current.innerHTML = templateContent;
                                }
                            });
                        }
                    }}
                    sx={{ backgroundColor: 'white' }}
                    MenuProps={MenuProps}
                >
                    {states.templateList.length > 0 ? states.templateList.map((item) => (
                        <MenuItem value={item.id} key={item.id}>
                            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} width={'100%'} alignItems={'center'} >
                                {item.template_name.length > 13 ? <Tooltip title={item.template_name} placement='top'><Typography>{item.template_name.slice(0, 13) + '...'}</Typography></Tooltip> : <Typography>{item.template_name}</Typography>}
                                {item.default_template && (
                                    <img src={ImagePaths.DefaultIcon.default} style={{ width: '1.2vw', height: '1.2vw' }} alt='default' />
                                )}
                            </Box>
                        </MenuItem>
                    )) : <Typography align='center'>{t('NDF')}</Typography>}
                    <Divider />
                    <List>
                        {this.state.edittempName && (
                            <List>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => {
                                        const selected = this.state.templateList.find(item => item.id == this.state.selectTemplate);
                                        this.setState({
                                            isTempAdd: true,
                                            addLayoutName: selected?.template_name || '',
                                            selectedID: selected?.id
                                        });
                                    }}>
                                        <ListItemText primary={"Rename"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => {
                                        this.setState({ deleteTemp: true, selecDelID: this.state.selectTemplate });
                                    }}>
                                        <ListItemText primary={"Delete"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => {
                                        const selected = this.state.templateList.find(item => item.id == this.state.selectTemplate);
                                        if (selected?.default_template) {
                                            this.setState({
                                                addLayoutName: selected?.template_name || '',
                                                tempContent: selected?.medical_notes || '',
                                                selectedID: selected?.id,
                                                isDefault: false
                                            }, () => {
                                                this.addTempLayout();
                                            });
                                        } else {
                                            this.setState({
                                                addLayoutName: selected?.template_name || '',
                                                tempContent: selected?.medical_notes || '',
                                                selectedID: selected?.id,
                                                isDefault: true
                                            }, () => {
                                                this.addTempLayout();
                                            });
                                        }
                                    }}>
                                        <ListItemText primary={
                                            (() => {
                                                const selected = this.state.templateList.find(item => item.id == this.state.selectTemplate);
                                                return selected?.default_template ? 'Remove Default' : 'Make as Default';
                                            })()
                                        } />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        )}
                    </List>
                </Select>
            </FormControl>
        )
    }

    render() {
        let states = this.state;
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'73vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'} width={'100%'}>
                    <Box component={'div'} width={'65%'}>
                        <Box border={'1px solid lightgray'} height={'5.15vh'} display={'flex'} pl={'0.5vw'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography fontWeight={600}>{"Medical Certificate"}</Typography>
                            {this.renderTemplateDropdown()}
                        </Box>
                        <Box border={'1px solid lightgray'} height={"calc(100% - 11.15vh)"} p={"1.5vw"} sx={{ overflowY: 'auto' }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", height: "10vh" }}>
                                <div style={{ width: '33%' }}></div>
                                <div style={{ fontSize: "1.1vw", fontWeight: "600", textAlign: "center", width: '33%' }}>{`MEDICAL CERTIFICATE`}</div>
                                <div style={{ width: '33%', textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', wordBreak: 'break-word' }}>
                                    <div>Place</div>
                                    <div>
                                        {states.doctor_details?.city_name ? (
                                            states.doctor_details.city_name.length > 20 ? (
                                                <Tooltip title={states.doctor_details.city_name} placement="top" arrow>
                                                    <Typography>{`${states.doctor_details.city_name.slice(0, 17)}...`}</Typography>
                                                </Tooltip>
                                            ) : (<Typography>{states.doctor_details.city_name}</Typography>)
                                        ) : ''}
                                    </div>
                                </div>
                            </div>
                            <div>Signature of Applicant .........................</div>
                            <br />
                            <Box
                                ref={this.boxRef}
                                contentEditable
                                suppressContentEditableWarning={true}
                                sx={{
                                    width: "100%",
                                    overflowY: "auto",
                                    fontSize: "1rem",           // 16px
                                    lineHeight: "1.4375em",     // ~23px
                                    height: `${5 * 23}px`,      // rows * line-height ≈ 115px
                                    whiteSpace: "pre-wrap",
                                    outline: "none",
                                    fontWeight: 400,
                                }}
                                spellCheck="false"
                                onInput={() => {
                                    if (this.boxRef.current) {
                                        this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                    }
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    const text = e.clipboardData.getData("text/plain");

                                    const sel = window.getSelection();
                                    if (!sel.rangeCount) return;
                                    const range = sel.getRangeAt(0);
                                    range.deleteContents();
                                    range.insertNode(document.createTextNode(text));

                                    // Move caret to end of inserted text
                                    range.collapse(false);
                                    sel.removeAllRanges();
                                    sel.addRange(range);

                                    if (this.boxRef.current) {
                                        this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stop default <div>/<br>

                                        const sel = window.getSelection();
                                        if (!sel.rangeCount) return;

                                        const range = sel.getRangeAt(0);

                                        // Insert newline at caret
                                        const textNode = document.createTextNode("\n");
                                        range.insertNode(textNode);

                                        // Move cursor after the newline
                                        range.setStartAfter(textNode);
                                        range.setEndAfter(textNode);

                                        sel.removeAllRanges();
                                        sel.addRange(range);

                                        // Ensure caret stays visible
                                        setTimeout(() => {
                                            if (this.boxRef.current) {
                                                this.boxRef.current.scrollTop = this.boxRef.current.scrollHeight;
                                            }
                                        }, 0);
                                    }
                                }}
                            />
                            <div style={{ marginTop: "5vh", display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <div>Signature of Medical Officer /</div>
                                <div>Doctor along with official seal</div>
                                <br />
                                <div>{`Registration No. ${states.doctor_details?.regNo ? states.doctor_details?.regNo : ''}`}</div>
                            </div>
                            <div>Date: {`${states?.date ? DateTime.fromJSDate(states?.date).toFormat('dd-MM-yyyy') : ''}`}</div>
                        </Box>
                        <Box display={'flex'} justifyContent={'center'} mt={'.5vw'}>
                            <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }} disabled={this.state.disableInputs || getCachevalue('DoctorUserChanged') === 'true'} onClick={() => { this.handleTemplateValidation() }}>{'Add Template'}</Button>
                        </Box>
                    </Box>
                    <Box component="div" width={'35%'} border="1px solid lightgray" height={"61.5vh"}>
                        <Box height="5.15vh" display="flex" pl="0.5vw" alignItems="center">
                            <Typography fontWeight={600}>Medical Certificate</Typography>
                        </Box>
                        <Box sx={{ height: '50vh', overflow: 'auto', backgroundColor: Colors.white }}>
                            {this.renderTextField("Company/Office Name *", "companyName", true)}
                            {this.renderTextField("Designation", "designation")}
                            <hr />
                            <Typography p={'0.5vw'}>Diagnosis Details</Typography>
                            {this.renderTextField("Diagnosis Details Here *", "diagnosisDetails")}
                            <hr />
                            <Typography style={{ margin: '0.5vw' }}>Date Details</Typography>
                            <Box display="flex">
                                {this.renderDatePicker("From Date *", "fromDate", "fromDateOpen")}
                                {this.renderDatePicker("To Date *", "toDate", "toDateOpen")}
                            </Box>
                            {this.renderDatePicker("Effective Date *", "effectiveDate", "effectiveDateOpen")}
                            <hr />
                            {this.renderTextField("Place *", "city_name")}
                            <Box display="flex">
                                {this.renderDatePicker("Date *", "date", "dateOpen")}
                                {this.renderTextField("Registration No *", "regNo")}
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" height="6.18vh">
                            {this.state.disableInputs ? <Button
                                variant='outlined'
                                emed_tid='medical_certifi_reset'
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                onClick={() => { this.handleclear() }}
                            >{"Reset"}</Button> : null}
                            <Button
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                variant="outlined"
                                emed_tid='medical_certifi_save'
                                disabled={this.state.disableBtn || getCachevalue('DoctorUserChanged') === 'true'}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleValidation())}
                            >
                                Save
                            </Button>
                            <Button
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                                variant="contained"
                                emed_tid='medical_certifi_print'
                                disabled={!this.state.id || this.state.disableBtn}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleMedCertifiPrint())}
                            >
                                Print
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <div>
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}

                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                </div>
                <Loader loaderOpen={this.state.isLoader} />
                {this.state.isTempAdd ? this.renderLayAdd() : null}
                {this.state.deleteTemp ? <ConfirmPopup
                    cnfTitle={this.props.t('Confirmation')}
                    cnfContent={this.props.t('Are you sure, Do you want Delete the Template')}
                    cnfAlertPopupClose={this.popClose.bind(this)}
                    cnfData={this.deleteTempData.bind(this)}
                /> : null}
            </Box>
        )
    }
}

export default withTranslation()(DocMedicalCertific);